/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataAnalyticsProfileWithCommitmentResponse } from '../../models/data-analytics-profile-with-commitment-response';

export interface DataAnalyticsCommitments$Params {
  count: number;
}

export function dataAnalyticsCommitments(http: HttpClient, rootUrl: string, params: DataAnalyticsCommitments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataAnalyticsProfileWithCommitmentResponse>>> {
  const rb = new RequestBuilder(rootUrl, dataAnalyticsCommitments.PATH, 'get');
  if (params) {
    rb.path('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DataAnalyticsProfileWithCommitmentResponse>>;
    })
  );
}

dataAnalyticsCommitments.PATH = '/rest/data-analytics/commitments/{count}';
